import { render } from "./CustomerDiscountGroupsManagement.html?vue&type=template&id=fcc31d0e&scoped=true"
import script from "./CustomerDiscountGroupsManagement.js?vue&type=script&lang=js"
export * from "./CustomerDiscountGroupsManagement.js?vue&type=script&lang=js"

import "./CustomerDiscountGroupsManagement.css?vue&type=style&index=0&id=fcc31d0e&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc31d0e"]])

export default __exports__